module.exports = __webpack_public_path__ + "static/img/jiariLogo.b7b5ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiariLogo.png
// module id = bRKC
// module chunks = 5